// What a collaborative editor shows of the other people in it: a colour for each person (their cursor's, from a hue
// the server derives from their id) and a row of small initials chips for whoever else is here.

// #rrggbb from a hue (the cursor extensions only take six-digit hex).
export function hueToHex(hue) {
    const [s, l] = [0.65, 0.42]
    const a = s * Math.min(l, 1 - l)
    const channel = (n) => {
        const k = (n + hue / 30) % 12
        return Math.round(255 * (l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1)))).toString(16).padStart(2, "0")
    }
    return `#${channel(0)}${channel(8)}${channel(4)}`
}

// Fills `container` with one chip per other person in the awareness (a person with two tabs shows once), hidden when
// nobody else is here.
export function renderPeers(container, awareness, selfId) {
    if (!container) return

    const peers = [...awareness.getStates()].filter(([id, state]) => id !== selfId && state.user)
    const seen = new Set()
    container.replaceChildren(...peers.filter(([, state]) => !seen.has(state.user.name) && seen.add(state.user.name)).map(([, state]) => {
        const chip = document.createElement("span")
        chip.className = "collab-peer"
        chip.title = `${state.user.name} is here`
        chip.style.setProperty("--peer", state.user.color)
        chip.textContent = state.user.name.split(/\s+/).slice(0, 2).map((word) => word[0]).join("").toUpperCase()
        return chip
    }))
    container.hidden = peers.length === 0
}
